import React from "react";
import { Segment } from "semantic-ui-react";
import GramTable from "./GramTable";
import GermTable from "./GermTable";
import AntiTable from "./AntiTable";

const Sample = ({ muestra, maxNroMuestras, orderDate, comentarioAnti }) => {
  let testName = "";
  let sampleNumber = "";

  if (muestra.gram.length > 0) {
    testName = muestra.gram[0].nombre_examen;
    sampleNumber = muestra.gram[0].nro_muestra;
  } else if (muestra.germ.length > 0) {
    testName = muestra.germ[0].nombre_examen;
    sampleNumber = muestra.germ[0].nro_muestra;
  } else if (muestra.anti.length > 0) {
    testName = muestra.anti[0].nombre_examen;
    sampleNumber = muestra.anti[0].nro_muestra;
  }

// Agrupar antibióticos por examen y germen
const antibioticsByExam = {};

// Crear gérmenes aunque no tengan antibióticos
muestra.germ.forEach(germ => {
  if (!germ.desc_germen || germ.desc_germen === "A/B" 
    || germ.desc_germen === "Positivo" 
    || germ.desc_germen === "Negativo"
    || germ.desc_germen === "Preliminar"
    || germ.desc_germen === "Directo"
    || germ.desc_germen === "Coloración"
    || germ.desc_germen === "POSITIVO"
    || germ.desc_germen === "Resultado"
    || germ.desc_germen === "Deteccion"
    || germ.desc_germen === "Leucocitos"
    || germ.desc_germen === "2"
    || germ.desc_germen === "1"
    || germ.desc_germen === "3"
    || germ.desc_germen === "0"
) return;

  const examen = germ.codigo_examen + "_" + germ.nro_muestra;
 
  const comentariosMap = comentarioAnti.reduce((acc,c)=>{
    if(Number(c.posicion)>200){
      acc[Number(c.posicion)] = c;
    }
    return acc;
  },{});

  if (!antibioticsByExam[examen]) {
    antibioticsByExam[examen] = {
      nombre_examen: germ.nombre_examen,
      germenes: []
    };
  }

  antibioticsByExam[examen].germenes.push({
    desc_germen: germ.desc_germen,
    id_anti: germ.id_anti,
    comentario: comentariosMap[germ.id_anti] || null,
    antibioticos: []
  });
});

 console.log("ANTIBYEXAM",antibioticsByExam, muestra)

muestra.anti.forEach(anti => {
  const examen = anti.codigo_examen + "_" + anti.nro_muestra;
  const germ = muestra.germ.find(g => g.id_anti === anti.id_germ);
  if (!germ) return;

  const examGroup = antibioticsByExam[examen];
  if (!examGroup) return;

  const existingGerm = examGroup.germenes.find(
    g => g.desc_germen === germ.desc_germen
  );
  if (!existingGerm) return;

  // Evitar duplicados
  const nombresExistentes = new Set(existingGerm.antibioticos.map(a => a.nombre));
  if (!nombresExistentes.has(anti.nombre)) {
    existingGerm.antibioticos.push(anti);
  }
});

/*muestra.anti.forEach(anti => {
  const examen = anti.codigo_examen + "_" + anti.nro_muestra;

  if (!antibioticsByExam[examen]) {
    antibioticsByExam[examen] = { nombre_examen: anti.nombre_examen, germenes: [] };
  }

  // Buscar germen asociado a este antibiótico
  const germ = muestra.germ.find(g => g.id_anti === anti.id_germ);
  if (!germ || !germ.desc_germen || germ.desc_germen === "A/B" || germ.desc_germen === "Positivo") return;

  let existingGerm = antibioticsByExam[examen].germenes.find(g => g.desc_germen === germ.desc_germen);
  if (!existingGerm) {
    existingGerm = { desc_germen: germ.desc_germen, antibioticos: [] };
    antibioticsByExam[examen].germenes.push(existingGerm);
  }

  // Evitar duplicados
  const nombresExistentes = new Set(existingGerm.antibioticos.map(a => a.nombre));
  if (!nombresExistentes.has(anti.nombre)) {
    existingGerm.antibioticos.push(anti);
  }
});*/

return (
    <div style={{ paddingBottom: 10 }}>
      
      {//muestra.gram.length > 0 && (
        false && (
        <GramTable results_gram={muestra.gram} maxNroMuestras={maxNroMuestras} />
      )}

      {//muestra.germ.length > 0 && ( //se cancela para que no se visualize
        false && (
        <GermTable results_germ={muestra.germ} orderDate={orderDate} />
      )}

      {}
      {Object.entries(antibioticsByExam).map(([examen, groupedAntibiotics], idx) => (
        <div key={idx}> 
        <Segment 
          className="sampleSegment"
          style={{
            marginTop:10, 
            marginBotton:3,
           }}
        >{groupedAntibiotics.nombre_examen  }</Segment>
        {console.log(groupedAntibiotics)}
        <AntiTable 
        groupedAntibiotics={groupedAntibiotics.germenes} 
        comentarioAnti={comentarioAnti}>
        </AntiTable>
        </div>
      ))

      }
    </div>
  );
};

export default Sample;
